import type { HubHttpClient } from 'rpc-client-utils';
// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
import {
  getIsThemePreview,
  getPortalAccountId,
  getPortalInstanceId,
  getPreviewJwt,
} from './utils/metadata';

export type PortalsHttpClientOptions = {
  prefix: string;
};

type ClientInfo = {
  accountId?: number;
  portalInstanceId?: number;
  previewJwt?: string;
};

const portalsHttpClient = createPortalsHttpClient({
  prefix: '/_hcms/portals-platform',
});

const isThemePreview = getIsThemePreview();
const previewJwt = getPreviewJwt();

export default portalsHttpClient;

export function createPortalsHttpClient({
  prefix,
}: PortalsHttpClientOptions): HubHttpClient {
  return {
    post: async (url, options) => {
      const requestUrl = new URL(url, window.location.origin);
      const resolvedPath = requestUrl.pathname;
      let clientInfo: ClientInfo = {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId(),
      };
      if (isThemePreview) {
        clientInfo = { previewJwt };
      }
      const queryString = options?.query
        ? `?${new URLSearchParams(options.query).toString()}`
        : '';
      const proxiedUrl = `${prefix}${resolvedPath}${queryString}`;
      const data = await fetch(proxiedUrl, {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...options?.headers,
          'X-Hs-Membership-Csrf': Cookies.get('hs-membership-csrf'),
        },
        body: JSON.stringify(
          options?.data
            ? {
                ...options.data,
                ...clientInfo,
              }
            : {
                ...clientInfo,
              }
        ),
      });
      return data.json();
    },
    get: () => {
      throw new Error('Only POST requests are supported');
    },
    delete: () => {
      throw new Error('Only POST requests are supported');
    },
    put: () => {
      throw new Error('Only POST requests are supported');
    },
    patch: () => {
      throw new Error('Only POST requests are supported');
    },
  } satisfies HubHttpClient;
}
